import {useQuery}     from "react-query";
import StripeService  from "../services/stripe.service";
import {CustomerType} from "../types/stripeCustomer.type";

export function useStripeCustomer(customer: CustomerType, handleFetchCustomerSubscriptions: (res: any) => void) {
    const {
              isFetching: isFetchingCustomerSubscriptions,
              refetch   : fetchCustomerSubscriptions,
          } = useQuery<any[], Error>(
        "query-fetch-customer-subscriptions",
        async () => {
            if (customer === null) return null;
            return await StripeService.fetchListCustomerSubscriptions(customer.customer_id);
        },
        {
            enabled  : false,
            retry    : 3,
            onSuccess: (res) => {
                handleFetchCustomerSubscriptions(res);
            },
            onError  : (err: any) => {
                console.error(`[ERROR] Error in fetchCustomerSubscriptions:`, err);
            },
        }
    );
    return {isFetchingCustomerSubscriptions, fetchCustomerSubscriptions};
}

